// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1sHlH","title":"Images45_title__2Uv4Q","images":"Images45_images__JZyN4"};